/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { leftIcon, modalContainer } from "@/src/theme/commonStyle";

const groupStyle = {
  leftIcon,
  modalContainer,
  input: {
    visibility: "hidden",
  },
  formHelperText: {
    textAlign: "center",
    fontSize: "1rem",
  },
  fieldset: {
    width: "100%",
    alignItems: "center",
  },
};

export default groupStyle;
